module.exports = __webpack_public_path__ + "static/img/icon03.2ad1a93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/culture/icon03.png
// module id = 4T1/
// module chunks = 1